<template>
  <div class="space-y-16 max-w-5xl mx-auto">
    <!-- <div class="flex flex-wrap items-stretch -mx-4">
      <div class="w-full sm:mt-8 md:w-1/2 lg:w-1/3 px-4 flex">
        <div class="card flex flex-col">
          <div class="flex flex-col flex-1 px-6 pt-6 pb-3 space-y-2">
            <span class="uppercase text-xs text-gray-600">
              Reach
            </span>
            <h5
              v-if="facebookCampaign.lifetimeReport
                && facebookCampaign.lifetimeReport.reach"
            >
              {{ facebookCampaign.lifetimeReport.reach | thousands }}
            </h5>
          </div>
          <div class="px-6 pb-6 space-y-2">
            <span class="uppercase text-xs text-gray-600">
              Frequency
            </span>
            <h5
              v-if="facebookCampaign.lifetimeReport
                && facebookCampaign.lifetimeReport.impressions"
            >
              {{ facebookCampaign.lifetimeReport.frequency | currencyDisplay }}
            </h5>
          </div>
          <div class="relative p-0">
            <LineChart
              :chart-data="reachChartData"
              :options="options"
            />
          </div>
        </div>
      </div>
      <div class="w-full sm:mt-8 md:w-1/2 lg:w-1/3 px-4 flex">
        <div class="card flex flex-col">
          <div class="flex flex-col flex-1 px-6 pt-6 pb-3">
            <div class="flex">
              <div class="flex-1 space-y-2">
                <span class="uppercase text-xs text-gray-600">
                  Visits
                </span>
                <h5>{{ facebookCampaign.lifetimeReport.inlineLinkClicks | thousands }}</h5>
              </div>
              <div class="flex-1 space-y-2 text-right">
                <span class="uppercase text-xs text-gray-600">
                  Conversion
                </span>
                <h5 class="text-red-500">
                  {{ lifetimeConversion | currencyDisplay }} %
                </h5>
              </div>
            </div>
          </div>
          <div class="px-6 pb-6 space-y-2">
            <span class="uppercase text-xs text-gray-600">
              Cost Per Click
            </span>
            <h5>
              {{ lifetimeCostPerClick }} &euro;
            </h5>
          </div>
          <div class="relative p-0">
            <LineChart
              :chart-data="inlineLinkClicksChartData"
              :options="options"
            />
          </div>
        </div>
      </div>
      <div class="w-full sm:mt-8 lg:w-1/3 px-4 flex">
        <div class="card flex flex-col">
          <div class="flex flex-col flex-1 px-6 pt-6 pb-3 space-y-2">
            <span class="uppercase text-xs text-gray-600">
              Spend
            </span>
            <h5
              v-if="facebookCampaign.lifetimeReport
                && facebookCampaign.lifetimeReport.spend"
            >
              {{ facebookCampaign.lifetimeReport.spend }} &euro;
            </h5>
          </div>
          <div class="relative p-0">
            <LineChart
              :chart-data="spendChartData"
              :options="options"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div>
      <InsightsChart :daily-reports="facebookCampaign.dailyReports">
        <template #default="props">
          <LineChart :chart-data="props.chartData" :options="props.options" />
        </template>
      </InsightsChart>
    </div>
  </div>
</template>

<script>
import InsightsChart from './InsightsChart.vue';

const LineChart = () => import('@/components/Ui/LineChart.vue');

export default {
  components: {
    LineChart,
    InsightsChart,
  },
  props: {
    facebookCampaign: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    datacollection: null,
    options: {
      responsive: true,
      aspectRatio: 3,
      layout: {
        padding: {
          top: 10,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          display: false,
        },
        y: {
          display: false,
        },
      },
      elements: {
        line: {
          tension: 0,
          borderCapStyle: 'round',
        },
        point: {
          radius: 0,
        },
      },
    },
  }),
  computed: {
    lifetimeConversion() {
      const { inlineLinkClicks, reach } = this.facebookCampaign?.lifetimeReports || {};
      if (!inlineLinkClicks || !reach) return 0;
      return (inlineLinkClicks / reach) * 100;
    },
    lifetimeCostPerClick() {
      const { spend, inlineLinkClicks } = this.facebookCampaign?.lifetimeReports || {};
      if (!spend || !inlineLinkClicks) return 0;
      return (spend / inlineLinkClicks).toFixed(2);
    },
    sortedAsc() {
      return (this.facebookCampaign?.dailyReports || []).slice(0).sort((reportA, reportB) => {
        const [yearA, monthA, dayA] = reportA.dateFrom.split('-');
        const dateA = new Date(yearA, monthA - 1, dayA, 0, 0, 0);

        const [yearB, monthB, dayB] = reportB.dateFrom.split('-');
        const dateB = new Date(yearB, monthB - 1, dayB, 0, 0, 0);

        return dateA - dateB;
      });
    },
    minDate() {
      const [firstReport] = this.sortedAsc.slice(0, 1);
      return firstReport ? firstReport.dateFrom || null : null;
    },
    maxDate() {
      const [lastReport] = this.sortedAsc.slice(-1);
      return lastReport ? lastReport.dateFrom || null : null;
    },
    consecutiveDateRange() {
      const labels = [];
      const { minDate, maxDate } = this;
      if (!minDate) return [];
      const firstDate = this.parseDate(minDate);
      const lastDate = this.parseDate(maxDate);
      for (let date = firstDate; date <= lastDate; date.setDate(date.getDate() + 1)) {
        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        labels.push(`${year}-${month}-${day}`);
      }
      return labels;
    },
    reachChartData() {
      const { consecutiveDateRange: period } = this;
      if (!period) return [];
      const data = period.map((label) => {
        const report = (this.facebookCampaign?.dailyReports || []).find(
          (dailyReport) => dailyReport.dateFrom === label
        );
        const { reach = null } = report || {};
        return reach;
      });
      return {
        labels: period,
        datasets: [
          {
            label: 'reach',
            borderColor: '#6574cd',
            backgroundColor: '#b2b7ff',
            borderWidth: 2,
            data,
            spanGaps: false,
            pointHitRadius: 10,
            pointBackgroundColor: '#6574cd',
            pointHoverRadius: 6,
          },
        ],
      };
    },
    spendChartData() {
      const { consecutiveDateRange: period } = this;
      if (!period) return [];
      const data = period.map((label) => {
        const report = (this.facebookCampaign?.dailyReports || []).find(
          (dailyReport) => dailyReport.dateFrom === label
        );
        const { spend = null } = report || {};
        return spend;
      });
      return {
        labels: period,
        datasets: [
          {
            label: 'spend',
            borderColor: '#6574cd',
            backgroundColor: '#b2b7ff',
            borderWidth: 2,
            data,
            spanGaps: false,
            pointHitRadius: 10,
            pointBackgroundColor: '#6574cd',
            pointHoverRadius: 6,
          },
        ],
      };
    },
    inlineLinkClicksChartData() {
      const { consecutiveDateRange: period } = this;
      if (!period) return [];
      const data = period.map((label) => {
        const report = (this.facebookCampaign?.dailyReports || []).find(
          (dailyReport) => dailyReport.dateFrom === label
        );
        const { inlineLinkClicks = null } = report || {};
        return inlineLinkClicks;
      });
      return {
        labels: period,
        datasets: [
          {
            label: 'clicks',
            borderColor: '#6574cd',
            backgroundColor: '#b2b7ff',
            borderWidth: 2,
            data,
            spanGaps: false,
            pointHitRadius: 10,
            pointBackgroundColor: '#6574cd',
            pointHoverRadius: 6,
          },
        ],
      };
    },
  },
  methods: {
    parseDate(value) {
      const [year, month, day] = value.split('-');
      return new Date(year, month - 1, day, 0, 0, 0);
    },
    normalizeData(values, additionalValues = []) {
      const sampleData = [...values, ...additionalValues];
      const sortedAsc = sampleData.sort((a, b) => a - b);
      const [min] = sortedAsc;
      const [max] = sortedAsc.slice(-1);
      return values.map((value) => {
        if (!value) return null;
        return (value - min) / (max - min);
      });
    },
  },
};
</script>
